import axiosIns from "@/libs/axios";
import axios from "axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getToolOptions(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("tool-options")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getTools(ctx, params) {
      let link = `tools`;
      if (params.year && params.previousYear) {
        link = `tools/previous-year/${params.year ??
          new Date().getFullYear().toString()}`;
      } else if (params.year) {
        link = `tools/year/${params.year}`;
      } else if (params.previousYear) {
        link = `tools/previous-year/${params.year ??
          new Date().getFullYear().toString()}`;
      }

      return new Promise((resolve, reject) => {
        axiosIns
          .get(link)
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    createNewTool(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveTool", data)
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    deleteTool(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteTool/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateTool({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`/updateTool/${payload.id}`, payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    createNewOption({ commit }, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/tools/createOption", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // working group tool side

    getWorkingGroupToolOptions(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("workingGroupTool-options")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getWorkingGroupTool(ctx, params) {
      let link = `workingGroupTools`;
      if (params.year && params.previousYear) {
        link = `workingGroupTools/previous-year/${params.year ??
          new Date().getFullYear().toString()}`;
      } else if (params.year) {
        link = `workingGroupTools/year/${params.year}`;
      } else if (params.previousYear) {
        link = `workingGroupTools/previous-year/${params.year ??
          new Date().getFullYear().toString()}`;
      }

      return new Promise((resolve, reject) => {
        axiosIns
          .get(link)
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    createNewWorkingGroupTool(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveWorkingGroupTool", data)
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    deleteWorkingGroupTool(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteWorkingGroupTool/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateWorkingGroupTool({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`/updateWorkingGroupTool/${payload.id}`, payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    createNewWorkingGroupToolOption({ commit }, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/workingGroupTools/createOption", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getWorkingGroupTools(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/workingGroupTools", { params })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    createWorkingGroupToolSubsectionInputs({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/workingGroupTools/create-subsection-inputs", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    updateWorkingGroupToolSubsectionInputs({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/workingGroupTools/update-subsection-inputs", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    getWorkingGroupToolSubsections(_, toolId) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/workingGroupTools/subsection-inputs/${toolId}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // Marks this working group's updates as seen by the current user only
    markWorkingGroupUpdatesRead(_, wgId) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`/workingGroupTools/${wgId}/mark-read`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteWorkingGroupToolSubsection(_, subsectionId) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`/workingGroupTools/subsection-inputs/${subsectionId}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    generateReport(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`/reports/generate-report/`, payload, {
            responseType: "blob",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    downloadPDF3(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("generate-national", data, { responseType: "blob" })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getWorkingGroupToolReport(ctx, payload = null) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/generate-working-group-tool-report", payload, {
            responseType: "blob",
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getWorkingGroupToolIndividualSubsectionReport(ctx, wg_id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(
            `/generate-working-group-tool-individual-subsection-report/${wg_id}`,
            {
              responseType: "blob",
            }
          )
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateRowOrder({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`/tools/update-row-order`, payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
